(function(){
  function iconSVG(kind){
    var icons = {
      instagram: '' +
        '<svg class="nm-social-icon nm-social-icon--instagram" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
          '<defs>' +
            '<linearGradient id="nmig26" x1="0" y1="32" x2="32" y2="0" gradientUnits="userSpaceOnUse">' +
              '<stop offset="0" stop-color="#f9ce34"/>' +
              '<stop offset="0.38" stop-color="#ee2a7b"/>' +
              '<stop offset="0.68" stop-color="#6228d7"/>' +
              '<stop offset="1" stop-color="#4f5bd5"/>' +
            '</linearGradient>' +
          '</defs>' +
          '<rect x="2" y="2" width="28" height="28" rx="8" fill="url(#nmig26)"/>' +
          '<rect x="8.15" y="8.15" width="15.7" height="15.7" rx="5.2" fill="none" stroke="#fff" stroke-width="2.2"/>' +
          '<circle cx="16" cy="16" r="3.7" fill="none" stroke="#fff" stroke-width="2.2"/>' +
          '<circle cx="23.1" cy="8.9" r="1.55" fill="#fff"/>' +
        '</svg>',
      tiktok: '' +
        '<svg class="nm-social-icon nm-social-icon--tiktok" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
          '<rect x="2" y="2" width="28" height="28" rx="8" fill="#101010"/>' +
          '<path d="M18.5 8.1c1 1.5 2.2 2.4 3.9 2.7v2.8a7.3 7.3 0 0 1-3.9-1.3v5.7c0 3.1-2.4 5.6-5.8 5.6-2.5 0-4.5-1.3-5.5-3.4.9.6 2 1 3.3 1 2.3 0 4.1-1.7 4.1-3.9V8h3.9v.1Z" fill="#25F4EE"/>' +
          '<path d="M17.7 7.2c1 1.5 2.2 2.4 3.9 2.7v2.7a7.3 7.3 0 0 1-3.9-1.3V17c0 3.1-2.4 5.6-5.8 5.6-1.3 0-2.5-.3-3.5-.9.8.2 1.4.4 2.3.4 2.3 0 4.1-1.7 4.1-3.9V7.2h2.9Z" fill="#FE2C55"/>' +
          '<path d="M17.9 7.6c1 1.5 2.2 2.4 3.8 2.7v2a6.9 6.9 0 0 1-3.8-1.2v7.1c0 3.2-2.6 5.6-5.8 5.6-1.2 0-2.4-.3-3.4-.9.8.2 1.5.3 2.2.3 2.2 0 4-1.6 4-3.8V7.6h3Z" fill="#fff"/>' +
        '</svg>',
      whatsapp: '' +
        '<svg class="nm-social-icon nm-social-icon--whatsapp" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
          '<rect x="2" y="2" width="28" height="28" rx="8" fill="#25D366"/>' +
          '<path d="M16 7.6c-4.6 0-8.4 3.7-8.4 8.3 0 1.5.4 3 1.2 4.3l-1 4.2 4.3-1.1a8.4 8.4 0 0 0 3.9 1c4.6 0 8.4-3.7 8.4-8.4 0-4.6-3.8-8.3-8.4-8.3Z" fill="#fff"/>' +
          '<path d="M20.4 18.6c-.3-.1-1.9-.9-2.1-1-.3-.1-.5-.1-.7.2l-.6.8c-.2.2-.3.3-.6.1-1.3-.6-2.4-1.5-3.2-2.7-.2-.3 0-.4.1-.6l.5-.5c.1-.2.2-.3.3-.5 0-.2 0-.4-.1-.5l-.9-2.1c-.2-.4-.4-.4-.7-.4h-.6c-.2 0-.5.1-.7.4-.3.4-1 1.1-1 2.6s1 2.9 1.2 3.2c.1.2 1.8 2.9 4.5 4 2.7 1 2.7.7 3.2.7.5 0 1.9-.8 2.2-1.5.3-.8.3-1.5.2-1.7-.1-.1-.3-.2-.6-.5Z" fill="#25D366"/>' +
        '</svg>',
      facebook: '' +
        '<svg class="nm-social-icon nm-social-icon--facebook" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
          '<rect x="2" y="2" width="28" height="28" rx="8" fill="#1877F2"/>' +
          '<path d="M18.2 26v-8.1h2.7l.4-3.1h-3.1v-2c0-.9.2-1.5 1.6-1.5h1.7V8.4c-.3 0-1.2-.1-2.2-.1-2.7 0-4.4 1.6-4.4 4.6v1.9h-3v3.1h3V26h3.3Z" fill="#fff"/>' +
        '</svg>'
    };
    return icons[kind] || '';
  }

  function detectKind(url){
    var u = (url || '').toLowerCase();
    if (u.indexOf('instagram') > -1) return 'instagram';
    if (u.indexOf('tiktok') > -1) return 'tiktok';
    if (u.indexOf('whatsapp') > -1 || u.indexOf('wa.me') > -1 || u.indexOf('api.whatsapp.com') > -1) return 'whatsapp';
    if (u.indexOf('facebook') > -1 || u.indexOf('fb.com') > -1) return 'facebook';
    return '';
  }

  function renderSharpSocials(){
    var modules = document.querySelectorAll('.sidebar-module.nm-contact-sidebar');
    modules.forEach(function(module){
      var content = module.querySelector(':scope > div:last-child');
      if (!content) return;
      var links = Array.prototype.slice.call(content.querySelectorAll('a'));
      var socials = [];
      links.forEach(function(a){
        var kind = detectKind(a.getAttribute('href') || '');
        if (!kind) return;
        if (socials.some(function(s){ return s.kind === kind; })) return;
        socials.push({ kind: kind, href: a.href });
        var holder = a.closest('p') || a;
        holder.classList.add('nm-contact-social-source');
      });
      if (!socials.length) return;
      var row = content.querySelector('.nm-contact-socials');
      if (!row){
        row = document.createElement('div');
        row.className = 'nm-contact-socials';
        content.appendChild(row);
      }
      row.innerHTML = socials.map(function(item){
        return '<a href="' + item.href + '" target="_blank" rel="noopener noreferrer" aria-label="' + item.kind + '">' + iconSVG(item.kind) + '</a>';
      }).join('');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderSharpSocials);
  } else {
    renderSharpSocials();
  }
  window.addEventListener('load', renderSharpSocials);
  setTimeout(renderSharpSocials, 1400);
})();
